import { MetadataModel } from "../models";

export default abstract class MetadataRepository {
  private _metadata: MetadataModel | null = null;

  get metadata() {
    return this._metadata;
  }

  set metadata(value: any) {
    if (value instanceof MetadataModel) {
      this._metadata = value;
    } else {
      if (MetadataModel.is(value)) {
        this._metadata = MetadataModel.from(value);
      } else {
        this._metadata = this._transform(value);
      }
    }
  }

  async loadMetadata(): Promise<void> {
    const data = await this._loadMetadata();
    this._metadata = this._transform(data);
  }

  protected abstract _loadMetadata(): Promise<any>;

  protected abstract _transform(data: any): MetadataModel;
}
